"use client"

import Link from "next/link"
import { ArrowRight } from "lucide-react"
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion"

export function ProgramAccordion({ programData }) {
  return (
    <div className="mt-6">
      <Accordion type="single" collapsible className="w-full">
        {programData.map((p) => (
          <AccordionItem key={p.slug} value={p.slug}>
            <AccordionTrigger className="text-left text-sm font-medium text-foreground hover:no-underline">
              <span className="flex items-center gap-2.5">
                {p.icon && <span className="text-lg">{p.icon}</span>}
                <span>{p.name}</span>
                <span className="text-xs font-normal text-muted-foreground">{p.desc}</span>
              </span>
            </AccordionTrigger>
            <AccordionContent>
              <div className="space-y-2 pt-1 pb-2">
                {p.questions.map((q) => (
                  <Link
                    key={q.id}
                    href={`/app?q=${q.id}`}
                    className="group flex flex-col gap-2 rounded-lg border p-4 transition-colors hover:bg-accent/50"
                  >
                    <p className="text-sm leading-relaxed text-foreground">{q.q}</p>
                    <span className="inline-flex items-center gap-1 text-[11px] font-medium text-primary opacity-0 transition-opacity group-hover:opacity-100">
                      Practice with AI interviewer <ArrowRight className="size-3" />
                    </span>
                  </Link>
                ))}
                <Link
                  href="/app"
                  className="group flex items-center justify-center gap-2 rounded-lg border border-dashed p-3 text-sm font-medium text-muted-foreground transition-colors hover:border-primary/30 hover:text-foreground"
                >
                  Practice more {p.icon} {p.name} questions in the app
                  <ArrowRight className="size-4 transition-transform group-hover:translate-x-0.5" />
                </Link>
              </div>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  )
}
